    angular.module('aprima-core').constant('PrmState', {
        Fnc: {
                HxTab: 'HxTab',
                RxTab: 'RxTab',
            },
        History: {
            Patient: {
                Medication: 'PatientMedicationHistory'
            }
        },
        Message: {
            ManualRxRefill: 'ManualRxRefillMessage'
        }
    });

